var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m88.7852021 63.884431h-16.3135593v60.115569h-24.7164277v-60.115569h-11.7552151v-21.127003h11.7552151v-13.6715709c0-9.7766485 4.6170144-25.0858571 24.9364407-25.0858571l18.3083442.07704602v20.50735628h-13.2838983c-2.1789439 0-5.2428292 1.0950371-5.2428292 5.7587804v12.4339166h18.4713168z"}));
}

SocialFacebook.defaultProps = {"height":"128","viewBox":"0 0 128 128","width":"128"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
